import React, { Fragment, useCallback, useState } from "react";
import { Drawer, Button, Col } from "antd";
import AddressForm from "./Form";
import './index.css';
import { MapProvider } from "./map.context";

export default function Address({ onChange, ...props }) {
  const [visible, setVisible] = useState(false)

  const onDrawerOpen = useCallback(() => {
    setVisible(true);
  }, [setVisible])

  const onDrawerClose = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  const onDataChange = useCallback((data) => {
    onChange(data);
    onDrawerClose();
  }, [onChange, onDrawerClose]);

  return (
    <Fragment>
      <Button type="link" onClick={onDrawerOpen}>
        Change
      </Button>
      <Drawer
        title="Address"
        placement="right"
        destroyOnClose
        width={480}
        onClose={onDrawerClose}
        visible={visible}
      >
        <MapProvider>
          <AddressForm onChange={onDataChange}  {...props}/>
        </MapProvider>
      </Drawer>
    </Fragment>
  )

}



// WEBPACK FOOTER //
// ./src/containers/Places/components/Address/index.js